import React, { useState, useEffect } from 'react';

import { ReactComponent as SearchIcon } from 'assets/images/search-icon.svg';

function SimpleSearchControl(props) {

  const [rootState, setRootState] = useState({
    searchText: '',
    modified: false
  });

  useEffect(function onSearchTextChange() {

    if (rootState.modified === false) {
      return;
    }

    props.onChange(rootState.searchText);

  }, [rootState.searchText]);

  function handleSearchControlChange(searchText) {

    setRootState(function updateRootState(rootState) {
      return {
        ...rootState,
        searchText,
        modified: true
      };
    });

  }

  function renderSearchControl() {

    const searchControlAttributes = {
      type: 'text',
      autoComplete: 'off',
      className: 'simple-search-input',
      placeholder: props.placeholder,
      value: rootState.searchText,
      onChange(event) {
        handleSearchControlChange(event.target.value);
      }
    };

    return <React.Fragment>

      <SearchIcon className="application-subtle-icon" />

      <input {...searchControlAttributes} />

    </React.Fragment>;
  }

  function renderMain() {

    return <div className="simple-search-control-main">
      {renderSearchControl()}
    </div>;

  }

  return renderMain();

}

export default SimpleSearchControl;